module.exports = __webpack_public_path__ + "static/img/smart.5618d9ab.png";